import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Box } from "atoms";
import { HomeContactCard, HomeImageSlider, HomeReviewSlider, PopUpModal } from "molecules";
import { HomeFeatured, HomeInfo, HomeKnowlegdeResources, HomeNewsEvents, HomeResources } from "./molecules";
import { appConstants } from "redux/constants";
import { generatePublicURL } from "utils/utilities";

export const HomePage = () => {   

  const dispatch = useDispatch();
  const { home, popUp } = useSelector(state => state.app); 
  const [ delayPopUp, setDelayPopUp ] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setDelayPopUp(true);
    }, 5000);
  }, []);

  return (
    <Box overflow="hidden">  
      {/* POP UP */}
      {(popUp && home?.popUp?.show && delayPopUp) && <PopUpModal
        isOpen={(popUp && home?.popUp?.show && delayPopUp)}
        onRequestClose={() => dispatch({type: appConstants.CLOSE_POP_UP})}
        ariaHideApp={false}
        title={home?.popUp?.title}
        image={generatePublicURL(home?.popUp?.image?.url)}
        links={home?.popUp?.links}
      />}
      {/* IMAGE SLIDER */}
      {home?.slider && <HomeImageSlider data={home?.slider}/>}      
      {/* ABOUT SECTION */}
      {home?.homeAbout && <HomeInfo
        title={home?.homeAbout?.title}
        desc={home?.homeAbout?.desc?.split("<br/>")}
        image={generatePublicURL(home?.homeAbout?.image?.url)}
        linkLabel={home?.homeAbout?.linkLabel}
        linkUrl={home?.homeAbout?.linkUrl}
        videoUrl={home?.homeAbout?.videoUrl}
      />} 
      {/* NAVCARDS */}
      {home?.featured?.length > 0 && <HomeFeatured
        data={home?.featured}
      />}       
      {/* NEWS AND EVENTS */}
      <HomeNewsEvents 
        news={home?.news}        
      />
      {/* RESOURCES SECTION */}
      {home?.resources && <HomeResources resources={home?.resources} />}
      {home?.moreInfo?.length > 0 && home?.moreInfo?.map((item) => (
        <HomeInfo
          key={item?.id}
          title={item?.title}
          desc={item?.desc?.split("<br/>")}
          image={item?.image ? generatePublicURL(item?.image?.url) : ""}
          linkLabel={item?.linkLabel}
          linkUrl={item?.linkUrl}
          videoUrl={item?.videoUrl}
        />      
      ))}       
      {/* REVIEW SLIDER */}
      <Box
        maxWidth="120rem"
        mx="auto"            
        mt={{xs: "5rem", md: "10rem"}}
        mb="5rem"
        px={{xs: "2rem", md: "4rem", lg: "0"}}
      >
        {home?.testimonials && <HomeReviewSlider reviews={home?.testimonials}/>}
      </Box>
      {home?.knowledgeResources && <HomeKnowlegdeResources
        data={home?.knowledgeResources}
      />}
      {/* CONTACT CARD */}
      <HomeContactCard/>
    </Box>
  );
};